export const ADD_INPUT_WITH_PROPS = 'addInputWithProps';
export const EDIT_INPUT_WITH_PROPS = 'editInputWithProps';
export const REMOVE_INPUT_WITH_PROPS = 'removeInputWithProps';


export const addInputWithProps = (payload) => ({
    type: ADD_INPUT_WITH_PROPS,
    payload
});

export const editInputWithProps = (id, props) => ({
    type: EDIT_INPUT_WITH_PROPS,
    payload: { id, props }
});

export const removeInputWithProps = (payload) => ({
    type: REMOVE_INPUT_WITH_PROPS,
    payload
});
